import { AccountSettings } from "~/features/account-settings/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { RoleGuard } from "~/shared/components/role-guard/role-guard.tsx";
import { ACCOUNT_SETTINGS_ROLES } from "~/shared/constants/page-roles.ts";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const AccountSettingsPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlAccountSettings");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	if (!isEnabled || isInternal) {
		return <Construction />;
	}

	return (
		<RoleGuard allowedRoles={ACCOUNT_SETTINGS_ROLES}>
			<AccountSettings />
		</RoleGuard>
	);
};
